import clsx from 'clsx';
import { Spinner } from "@heroui/spinner";

export default function Loader({ className = '', hasText = false }) {
  return (
    <>
      {hasText ? <Spinner classNames={{ label: "text-foreground mt-4" }} label={"Ładuję..."} variant="wave" color="default" />
        : <Spinner classNames={{ label: "text-foreground mt-4" }} variant="wave" color="default" />

      }
    </>

  );
}
